var _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHighlevel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.77734,
    y: 6.8042,
    width: 5.29216,
    height: 32.887,
    fill: "#FDC400"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28.8359,
    y: 6.8042,
    width: 5.29216,
    height: 32.887,
    fill: "#4ACF27"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.9287,
    y: 18.9951,
    width: 6.04819,
    height: 20.6961,
    fill: "#2896FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.47064 0L16.9413 8.93053H0L8.47064 0Z",
    fill: "#FDC400"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5292 0L39.9999 8.93053H23.0586L31.5292 0Z",
    fill: "#4ACF27"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 12.6633L28.4706 21.5939H11.5293L19.9999 12.6633Z",
    fill: "#2896FB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.77734 8.93042H11.0695V14.2226L5.77734 8.93042Z",
    fill: "#DAA900"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8359 8.93042H34.1281V14.2226L28.8359 8.93042Z",
    fill: "#51B346"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9287 21.594H22.9769V27.6422L16.9287 21.594Z",
    fill: "#1F81DB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlevel);
export default __webpack_public_path__ + "static/media/highlevel.1bd7ef4fbecbc519774600ec7cd89449.svg";
export { ForwardRef as ReactComponent };